import { armLobbyLanding } from 'components/SaloonLobby/lobbyLanding';
import { showPersistedSitgoSeats } from 'components/SaloonLobby/useLobbyFilters';

import { sitgoSeatsForCapacity } from './sitGoResultDetection';

/**
 * EN-11109: arm the lobby to open on its Sit & Go tab with the format just
 * played turned on in the seat toggle (capacity 2 → Heads-up, otherwise
 * Six-seat; the other format is left as it was, and an unknown capacity
 * changes nothing). Only called when an exit from a finished Sit & Go falls
 * back to the lobby — never when it hops to another open table.
 *
 * The same with release.sit-go-buy-in-lobby on or off: that flag changes the
 * tab's layout only, and its sections are filtered by this toggle too.
 */
export const landOnSitGoTab = (capacity: number): void => {
  if (capacity > 0) showPersistedSitgoSeats(sitgoSeatsForCapacity(capacity));
  armLobbyLanding('sitgo');
};
